// For Product.js File Data
export const portfolioItems = [
  {
    title: 'RW–01', category: 'Aluminum', img: '1', ProfileSize : '55 mm X 70 mm', Weight : '0.700 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (1).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (1).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (1).jpg',
    }
  },
  {
    title: 'RW–02', category: 'Aluminum', img: '2',  ProfileSize : '71 mm X 81 mm', Weight : '0.850 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (2).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (2).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (2).jpg',
    }
  },
  {
    title: 'RW–03', category: 'Aluminum', img: '3', ProfileSize : '66 mm X 70 mm', Weight : '0.600 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (3).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (3).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (3).jpg',
    }
  },
  {
    title: 'RW–04', category: 'Aluminum', img: '4', ProfileSize : '45 mm X 60 mm', Weight : '0.500 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (4).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (4).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (4).jpg',
    }
  },
  {
    title: 'RW–05', category: 'Aluminum', img: '5', ProfileSize : '37 mm X 81 mm', Weight : '0.950 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (5).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (5).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (5).jpg',
    }
  },
  {
    title: 'RW–06', category: 'Aluminum', img: '6',  ProfileSize : '40 mm X 100 mm', Weight : '1.100 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (6).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (6).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (6).jpg',
    }
  },
  {
    title: 'RW–07', category: 'Aluminum', img: '7',  ProfileSize : '41 mm X 115 mm', Weight : '1.500 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (7).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (7).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (7).jpg',
    }
  },
  {
    title: 'RW–08', category: 'Aluminum', img: '8',  ProfileSize : '60 mm X 100 mm', Weight : '1.100 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (8).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (8).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (8).jpg',
    }
  },
  {
    title: 'RW–09', category: 'Aluminum', img: '9',  ProfileSize : '60 mm X 120 mm', Weight : '1.500 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (9).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (9).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (9).jpg',
    }
  },
  {
    title: 'RW–10', category: 'Aluminum', img: '10',  ProfileSize : '50 mm X 90 mm', Weight : '0.950 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (10).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (10).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (10).jpg',
    }
  },
  {
    title: 'RW–11', category: 'Aluminum', img: '11',  ProfileSize : '70 mm X 125 mm', Weight : '1.800 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (11).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (11).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (11).jpg',
    }
  },
  {
    title: 'RW–12', category: 'Aluminum', img: '12',  ProfileSize : '56 mm X 90 mm', Weight : '0.250 gm (1 Feet) & Bracket (65 mm)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (12).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (12).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (12).jpg',
    }
  },
  {
    title: 'RW–13', category: 'Aluminum', img: '13',  ProfileSize : '70 mm X 100 mm', Weight : '0.450 gm (1 Feet) & Bracket (65 mm)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (13).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (13).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (13).jpg',
    }
  },
  {
    title: 'RW–14', category: 'Aluminum', img: '14',  ProfileSize : '65 mm X 100 mm', Weight : '0.450 gm (1 Feet) & Bracket (65 mm)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (14).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (14).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (14).jpg',
    }
  },
  {
    title: 'RW–15', category: 'Aluminum', img: '15',  ProfileSize : '70 mm X 100 mm', Weight : '0.450 gm (1 Feet) & Bracket (65 mm)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (15).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (15).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (15).jpg',
    }
  },
  {
    title: 'RW–16', category: 'Aluminum', img: '16',  ProfileSize : '90 mm X 115 mm', Weight : '0.450 gm (1 Feet) & Bracket (65 mm)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (16).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (16).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (16).jpg',
    }
  },
  {
    title: 'RW–17', category: 'Aluminum', img: '17',  ProfileSize : '71 mm X 81 mm', Weight : '700 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (17).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (17).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (17).jpg',
    }
  },
  {
    title: 'RW–18', category: 'Aluminum', img: '18',  ProfileSize : '37 mm X 81 mm', Weight : '700 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (18).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (18).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (18).jpg',
    }
  },
  {
    title: 'RW–19', category: 'Aluminum', img: '19',  ProfileSize : '57 mm X 71 mm', Weight : '750  gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (19).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (19).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (19).jpg',
    }
  },
  {
    title: 'RW–20', category: 'Aluminum', img: '20',  ProfileSize : '70 mm X 70 mm', Weight : '650 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (20).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (20).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (20).jpg',
    }
  },
  {
    title: 'RW–21', category: 'Aluminum', img: '21',  ProfileSize : '37 mm X 100 mm', Weight : '1200  gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (21).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (21).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (21).jpg',
    }
  },
  {
    title: 'RW–22', category: 'Aluminum', img: '22',  ProfileSize : '40 mm X 80 mm', Weight : '900 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (22).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (22).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (22).jpg',
    }
  },
  {
    title: 'RW–23', category: 'Aluminum', img: '23',  ProfileSize : '64 mm X 85 mm', Weight : '900 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (23).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (23).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (23).jpg',
    }
  },
  {
    title: 'RW–24', category: 'Aluminum', img: '24',  ProfileSize : '50 mm X 75 mm', Weight : '700 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (24).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (24).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (24).jpg',
    }
  },
  {
    title: 'RW–25', category: 'Aluminum', img: '25',  ProfileSize : '55 mm X 100 mm', Weight : '1150 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (25).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (25).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (25).jpg',
    }
  },
  {
    title: 'RW–26', category: 'Aluminum', img: '26',  ProfileSize : '60 mm X 105 mm', Weight : '1200 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (26).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (26).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (26).jpg',
    }
  },
  {
    title: 'RW–27', category: 'Aluminum', img: '27',  ProfileSize : '60 mm X 120 mm', Weight : '1.500 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (27).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (27).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (27).jpg',
    }
  },
  {
    title: 'RW–28', category: 'Aluminum', img: '28',  ProfileSize : '60 mm X 100 mm', Weight : '1300 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (28).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (28).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (28).jpg',
    }
  },
  {
    title: 'RW–29', category: 'Aluminum', img: '29',  ProfileSize : '65 mm X 120 mm', Weight : '1800 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (29).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (29).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (29).jpg',
    }
  },
  {
    title: 'RW–30', category: 'Aluminum', img: '30',  ProfileSize : '70 mm X 150 mm', Weight : '2000 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (30).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (30).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (30).jpg',
    }
  },
  {
    title: 'RW–31', category: 'Aluminum', img: '31',  ProfileSize : '81 mm X 110 mm', Weight : '1100 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (31).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (31).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (31).jpg',
    }
  },
  {
    title: 'RW–32', category: 'Aluminum', img: '32',  ProfileSize : '81 mm X 110 mm', Weight : '1100 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (32).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (32).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (32).jpg',
    }
  },
  {
    title: 'RW–33', category: 'Aluminum', img: '33',  ProfileSize : '55 mm X 90 mm', Weight : '160 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (33).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (33).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (33).jpg',
    }
  },
  {
    title: 'RW–34', category: 'Aluminum', img: '34',  ProfileSize : '60 mm X 115 mm', Weight : '270 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (34).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (34).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (34).jpg',
    }
  },
  {
    title: 'RW–35', category: 'Steel', img: '35',  ProfileSize : '40 mm X 200 mm', Weight : '160 gm (1 Feet)', Length : '13 ft / 16 ft', image: {
      MainImage: '/images/MainProduct/Main/MainImage (35).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (35).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (35).jpg',
    }
  },
  {
    title: 'RW–36', category: 'Steel', img: '36',
    Det: 'TOP MOUNTING HOLLOW SHORT SQUARE BALUSTER WITH GLASS HOLDING SYSTEM FOR BALCONY & STAIRCASE',
    Det1: 'The Product Named As H & B System Which Gives Marvelous Look Of Premises For Balcony & Staircase.',
    Det2: 'It’s elegant Look Provide The Perfect View Of The Premises.',
    Det3: 'Available In Different Finishes Like Gold, Black & S.S. Matt.',
    image: {
      MainImage: '/images/MainProduct/Main/MainImage (36).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (36).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (36).jpg',
    }
  },
  {
    title: 'RW–37', category: 'Steel', img: '37',
    Det: 'TOP MOUNTING SOLID ROUND SPIGOT WITH GLASS HOLDING SYSTEM FOR BALCONY',
    Det1: 'It provides Unique Combination Of Slotted Handrail & Round Sollid Spigot For Balcony.',
    Det2: 'It is Innovative Design Provide The Glorious Face - Lift Of The Premises.',
    Det3: 'Available In Different Finishes Like Gold, Rose Gold, Black & S.S. Matt',
    image: {
      MainImage: '/images/MainProduct/Main/MainImage (37).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (37).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (37).jpg',
    }
  },
  {
    title: 'RW–38', category: 'Steel', img: '38',
    Det: 'TOP MOUNTING SOLID ROUND SPIGOT WITH GLASS HOLDING SYSTEM FOR STAIRCASE',
    Det1: 'It provides Unique Perfection Of Slotted Handrail & Round Solid Spigot For Staircase.',
    Det2: 'It Provides Marvelous Look Of The Premises.',
    Det3: 'Available In Different Finishes Like Gold, Rose Gold, Black & S.S. Matt.',
    image: {
      MainImage: '/images/MainProduct/Main/MainImage (38).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (38).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (38).jpg',
    }
  },
  {
    title: 'RW–39', category: 'Steel', img: '39',
    Det: 'SIDE MOUNTING POINT FITTING WITH GLASS HOLDING SYSTEM FOR BALCONY & STAIRCASE',
    Det1: 'It Provides Aesthetic Look Of Handrail & Point Fitting For Balcony & Staircase.',
    Det2: 'It is Innovative Designs Provide The Glorious Face - Lift Of The Premises.',
    Det3: 'Available In Different Finishes Like Gold, Rose Gold, Black & S.S. Matt',
    image: {
      MainImage: '/images/MainProduct/Main/MainImage (39).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (39).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (39).jpg',
    }
  },
  {
    title: 'RW–40', category: 'Steel', img: '40',
    Det: 'TOP MOUNTING SOLID RECTANGLE SPIGOT WITH GLASS HOLDING SYSTEM FOR BALCONY',
    Det1: 'It Provides Perfect Combination of Slotted Handrail & Rectangle Solid Spigot for Balcony.',
    Det2: 'It is Innovative Design Provides the Glorious Face - Lift of The Premises.',
    Det3: 'Available In Different Finishes Like Gold, Rose Gold, Black & S.S. Matt.',
    image: {
      MainImage: '/images/MainProduct/Main/MainImage (40).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (40).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (40).jpg',
    }
  },
  {
    title: 'RW–41', category: 'Steel', img: '41',
    Det: 'TOP MOUNTING FLAT BALUSTER FOR BALCONY & STAIRCASE',
    Det1: 'The Product Named as H & B System Which Gives Stunning Look of Premises for Balcony & Staircase.',
    Det2: 'It Provides Aesthetic Look of Premises.',
    Det3: 'Available In Different Finishes Like Gold, Rose Gold, Black & S.S. Matt.',
    image: {
      MainImage: '/images/MainProduct/Main/MainImage (41).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (41).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (41).jpg',
    }
  },
  {
    title: 'RW–42', category: 'Steel', img: '42',
    Det1: 'Choudhary Steel Industries RW 23 BRT railing system is Bracket System. The Bracket is anchored with Bolts. The Bracket is in anodize, wooden and any other shade of powder-coating Finish.',
    Det2: 'The system is compatible with glass of 12mm thickness and 1000mm height. The bracket length is 55mm and must use 1 bracket/2.5 Feet.',
    Det3: 'Aero-dynamic design, stunning look-zero maintenance.',
    image: {
      MainImage: '/images/MainProduct/Main/MainImage (42).jpg',
      '3DImage': '/images/MainProduct/3D/3DImage (42).jpg',
      '2Diamge': '/images/MainProduct/2D/2Diamge (42).jpg',
    }
  },
];

export const tabData = {
  'tab-1': {
    label: 'Features',
    details: {
      'detail-1': '100% Recyclable',
      'detail-2': 'Easy Cleaning',
      'detail-3': 'Maintenance Free',
      'detail-4': 'Weather Proof',
      'detail-5': 'Robust for Higher Safety',
    },
  },
  'tab-2': {
    label: 'Specification',
    details: {
      'detail-1': 'Top Mounted Bracket system with continues cover profile',
      'detail-2': 'This Product can support glass height up tp full height',
    },
  },
  'tab-3': {
    label: 'Glass',
    details: {
      'detail-1': '12 mm Toughened Glass',
      'detail-2': '25 mm Laminated Glass',
    },
  },
  'tab-4': {
    label: 'Finishes',
    details: {
      'detail-1': 'Wooden',
      'detail-2': 'Anodized',
      'detail-3': 'Power Coating',
    },
  },
};

export const CategoryData = [
  {
    id: 'features-tab-1',
    title: 'Aluminium Hand Rail',
    products:[
  {
    "modelId": "RW-43",
    "image": "/images/ProductCat/whole/RW (1).webp",
    "size": "65 mm Round Pipe",
    "weight": "0.450 gm (1 Feet)",
    "length": ["13 ft", "16 ft"]
  },
  {
    "modelId": "RW-44",
    "image": "/images/ProductCat/whole/RW (2).webp",
    "size": "50 mm Round Pipe",
    "weight": "0.330 gm (1 Feet)",
    "length": ["13 ft", "16 ft"]
  },
  {
    "modelId": "RW-45",
    "image": "/images/ProductCat/whole/RW (3).webp",
    "size": "38 mm Round Pipe",
    "weight": "0.170 gm (1 Feet)",
    "length": ["13 ft", "16 ft"]
  },
  {
    "modelId": "RW-46",
    "image": "/images/ProductCat/whole/RW (4).webp",
    "size": "50 x 50 Square Pipe",
    "weight": "0.370 gm (1 Feet)",
    "length": ["13 ft", "16 ft"]
  },
  {
    "modelId": "RW-47",
    "image": "/images/ProductCat/whole/RW (5).webp",
    "size": "40 x 40 Square Pipe",
    "weight": "0.300 gm (1 Feet)",
    "length": ["13 ft", "16 ft"]
  },
  {
    "modelId": "RW-48",
    "image": "/images/ProductCat/whole/RW (6).webp",
    "size": "32 x 32 Square Pipe",
    "weight": "0.200 gm (1 Feet)",
    "length": ["13 ft", "16 ft"]
  },
  {
    "modelId": "RW-49",
    "image": "/images/ProductCat/whole/RW (7).webp",
    "size": "25 x 25 Square Pipe",
    "weight": "0.170 gm (1 Feet)",
    "length": ["13 ft", "16 ft"]
  },
  {
    "modelId": "RW-50",
    "image": "/images/ProductCat/whole/RW (8).webp",
    "size": "60 x 40 mm Pipe",
    "weight": "0.380 gm (1 Feet)",
    "length": ["13 ft", "16 ft"]
  },
  {
    "modelId": "RW-51",
    "image": "/images/ProductCat/whole/RW (9).webp",
    "size": "Triangle Pipe",
    "weight": "0.330 gm (1 Feet)",
    "length": ["13 ft", "16 ft"]
  },
  {
    "modelId": "RW-52",
    "image": "/images/ProductCat/whole/RW (10).webp",
    "size": "65 x 38 mm Pipe",
    "weight": "0.330 gm (1 Feet)",
    "length": ["13 ft", "16 ft"]
  },
  {
    "modelId": "RW-53",
    "image": "/images/ProductCat/whole/RW (11).webp",
    "size": "Small Right Angle Pipe",
    "weight": "0.230 gm (1 Feet)",
    "length": ["13 ft", "16 ft"]
  },
  {
    "modelId": "RW-54",
    "image": "/images/ProductCat/whole/RW (12).webp",
    "size": "Right Angle Pipe",
    "weight": "0.400 gm (1 Feet)",
    "length": ["13 ft", "16 ft"]
  },
  {
    "modelId": "RW-55",
    "image": "/images/ProductCat/whole/RW (13).webp",
    "size": "Incline Pipe",
    "weight": "0.380 gm (1 Feet)",
    "length": ["13 ft", "16 ft"]
  },
  {
    "modelId": "RW-56",
    "image": "/images/ProductCat/whole/RW (14).webp",
    "size": "Rajwadi Pipe",
    "weight": "0.330 gm (1 Feet)",
    "length": ["13 ft", "16 ft"]
  },
  {
    "modelId": "RW-57",
    "image": "/images/ProductCat/whole/RW (15).webp",
    "size": "60 x 60 Pipe",
    "weight": "0.400 gm (1 Feet)",
    "length": ["13 ft", "16 ft"]
  },
  {
    "modelId": "RW-58",
    "image": "/images/ProductCat/whole/RW (16).webp",
    "size": "Diamond Pipe",
    "weight": "0.380 gm (1 Feet)",
    "length": ["13 ft", "16 ft"]
  }
],
  },
  {
    id: 'features-tab-2',
    title: 'Aluminium Railing Bracket',
    products: [
  {
    "modelId": "RW-75",
    "name": "L-Bracket",
    "image": "/images/ProductCat/whole/RW (17).webp",
    "size": "65 mm x 100 mm"
  },
  {
    "modelId": "RW-76",
    "name": "T-Bracket",
    "image": "/images/ProductCat/whole/RW (18).webp",
    "size": "55 mm x 100 mm"
  },
  {
    "modelId": "RW-77",
    "name": "V-Bracket",
    "image": "/images/ProductCat/whole/RW (19).webp",
    "size": "50 mm x 100 mm"
  },
  {
    "modelId": "RW-78",
    "name": "Owel Bracket",
    "image": "/images/ProductCat/whole/RW (20).webp",
    "size": "50 mm x 100 mm"
  },
  {
    "modelId": "RW-79",
    "name": "Tower Bracket",
    "image": "/images/ProductCat/whole/RW (21).webp",
    "size": "50 mm x 100 mm"
  },
  {
    "modelId": "RW-80",
    "name": "Small Diamond Bracket",
    "image": "/images/ProductCat/whole/RW (22).webp",
    "size": "70 mm x 100 mm"
  },
  {
    "modelId": "RW-81",
    "name": "V-Bracket",
    "image": "/images/ProductCat/whole/RW (23).webp",
    "size": "50 mm x 100 mm"
  },
  {
    "modelId": "RW-82",
    "name": "Diamond Bracket",
    "image": "/images/ProductCat/whole/RW (24).webp",
    "size": "80 mm x 100 mm"
  },
  {
    "modelId": "RW-83",
    "name": "Side Mount Bracket",
    "image": "/images/ProductCat/whole/RW (25).webp",
    "size": "70 mm x 100 mm"
  }
],
  },
  {
    id: 'features-tab-3',
    title: 'Aluminium Railing Accessories',
    products: [
      {
        modelId: 'ARA-1',
        image: '/images/ProductCat/whole/RW (26).webp',
        size: '50 * 10 mm',
        Weight: '60gm',
        length: '60cm',
      },
      {
        modelId: 'ARA-2',
        image: '/images/ProductCat/whole/RW (27).webp',
        size: '60 * 12 mm',
        Weight: '70gm',
        length: '70cm',
      },
      {
        modelId: 'ARA-3',
        image: '/images/ProductCat/whole/RW (28).webp',
        size: '55 * 11 mm',
        Weight: '65gm',
        length: '65cm',
      },
      ...Array.from({ length: 7 }, (_, i) => ({
        modelId: `ARA-${i + 4}`,
        image: `/images/ProductCat/whole/RW (${i + 29}).webp`,
        size: '55 * 11 mm',
        Weight: '65gm',
        length: '65cm',
      })),
    ],
  },
  {
    id: 'features-tab-4',
    title: 'S.S. Glass Railing Bracket',
    products: [
      {
        modelId: 'SGRC-1',
        image: '/images/ProductCat/whole/RW (36).webp',
        size: '70 * 15 mm',
        Weight: '80gm',
        length: '90cm',
      },
      {
        modelId: 'SGRC-2',
        image: '/images/ProductCat/whole/RW (37).webp',
        size: '75 * 17 mm',
        Weight: '85gm',
        length: '95cm',
      },
      {
        modelId: 'SGRC-3',
        image: '/images/ProductCat/whole/RW (38).webp',
        size: '80 * 20 mm',
        Weight: '90gm',
        length: '100cm',
      },
      {
        modelId: 'SGRC-4',
        image: '/images/ProductCat/whole/RW (39).webp',
        size: '85 * 22 mm',
        Weight: '95gm',
        length: '105cm',
      },
      {
        modelId: 'SGRC-5',
        image: '/images/ProductCat/whole/RW (40).webp',
        size: '90 * 25 mm',
        Weight: '100gm',
        length: '110cm',
      },
      ...Array.from({ length: 5 }, (_, i) => ({
        modelId: `SGRC-${i + 6}`,
        image: `/images/ProductCat/whole/RW (${i + 41}).webp`,
        size: '90 * 25 mm',
        Weight: '100gm',
        length: '110cm',
      })),
    ],
  },
  {
    id: 'features-tab-5',
    title: 'Glass Railing Pipe',
    products: [
      {
        modelId: 'GRP-1',
        image: '/images/ProductCat/whole/RW (46).webp',
        size: '200 * 40 mm',
        Weight: '200gm',
        length: '200cm',
      },
      {
        modelId: 'GRP-2',
        image: '/images/ProductCat/whole/RW (47).webp',
        size: '220 * 45 mm',
        Weight: '220gm',
        length: '220cm',
      },
      {
        modelId: 'GRP-3',
        image: '/images/ProductCat/whole/RW (48).webp',
        size: '240 * 50 mm',
        Weight: '240gm',
        length: '240cm',
      },
      ...Array.from({ length: 6 }, (_, i) => ({
        modelId: `GRP-${i + 4}`,
        image: `/images/ProductCat/whole/RW (${i + 49}).webp`,
        size: '240 * 50 mm',
        Weight: '240gm',
        length: '240cm',
      })),
    ],
  },
  {
    id: 'features-tab-6',
    title: 'Invisible Grill Accessories',
    products: [
      {
        modelId: 'IGA-1',
        image: '/images/ProductCat/whole/RW (55).webp',
        size: '30 * 5 mm',
        Weight: '40gm',
        length: '40cm',
      },
      {
        modelId: 'IGA-2',
        image: '/images/ProductCat/whole/RW (56).webp',
        size: '35 * 6 mm',
        Weight: '45gm',
        length: '45cm',
      },
      {
        modelId: 'IGA-3',
        image: '/images/ProductCat/whole/RW (57).webp',
        size: '40 * 8 mm',
        Weight: '50gm',
        length: '50cm',
      },
      {
        modelId: 'IGA-4',
        image: '/images/ProductCat/whole/RW (58).webp',
        size: '45 * 9 mm',
        Weight: '55gm',
        length: '55cm',
      },
      ...Array.from({ length: 24 }, (_, i) => ({
        modelId: `IGA-${i + 5}`,
        image: `/images/ProductCat/whole/RW (${i + 59}).webp`,
        size: '45 * 9 mm',
        Weight: '55gm',
        length: '55cm',
      })),
    ],
  },
];
